<template lang="pug">
  v-container(fluid)
    v-row.px-md-10(align='center' justify='center')
      v-col(cols="12").text-center
        h1 {{translations.dashboard}}

      v-col.text-right.d-none.d-sm-block(cols="12")
        v-btn-toggle(v-model="toggle_exclusive")
          v-btn(@click="getLastWeek" color="secondary") {{translations.dateToggle.week}}
          v-btn(@click="getLastMonth" color="secondary") {{translations.dateToggle.month}}
          v-btn(@click="getLastYear" color="secondary") {{translations.dateToggle.year}}
          v-btn(@click="getLastTwoYears" color="secondary") {{translations.dateToggle.twoyears}}
          v-menu(ref="menu" v-model="menu", :close-on-content-click="false" transition="scale-transition"
              offset-y
              max-width="290"
              min-width="290")
            template(v-slot:activator="{ on }")
               v-btn(color="secondary" v-on="on") {{translations.dateToggle.custom}}
            v-date-picker.d-none.d-sm-block(@change="getCustomDate()" color="primary" v-model="customDate", :locale="$i18n.locale", :first-day-of-week="1" no-title scrollable range)
      v-col.d-block.d-sm-none(cols="12")
        v-menu(offset-y)
          template(v-slot:activator="{ on, attrs }")
            v-btn(color="secondary" dark v-bind="attrs" v-on="on") Dropdown
          v-list.pa-0(dense)
            v-list-item(@click="getLastWeek") {{translations.dateToggle.week}}
            v-list-item(@click="getLastMonth") {{translations.dateToggle.month}}
            v-list-item(@click="getLastYear") {{translations.dateToggle.year}}
            v-list-item(@click="getLastTwoYears") {{translations.dateToggle.twoyears}}
            v-list-item
              v-menu(ref="menu" v-model="menu", :close-on-content-click="false" transition="scale-transition"
                  offset-y
                  max-width="290"
                  min-width="290")
                template(v-slot:activator="{ on }")
                  v-btn(text small v-on="on") {{translations.dateToggle.custom}}
                v-date-picker.d-block.d-sm-none(@change="getCustomDate()" color="primary" v-model="customDate", :locale="$i18n.locale", :first-day-of-week="1" no-title scrollable range)

      v-col(cols="12")
        h2 {{translations.economicSection}}
        v-divider
      v-col(cols="12")
        v-card.elevation-0.px-md-10.pt-5
          v-row
            v-col(cols="12" md="6" sm="12").px-md-10.text-center
              v-card(color="primary" dark).elevation-10
                RevenueChart(:chart="reneuveChart")
              h2.py-5 {{translations.chars.revenue}}
            v-col(cols="12" md="6" sm="12").px-md-10.text-center
              v-card(color="primary" dark).elevation-10
                MoneyLineChart(:chart="moneyChart")
              h2.py-5 {{translations.chars.moneinout}}
      v-col(cols="12")
        h2 {{translations.usersSection}}
        v-divider

      v-col(cols="12")
          v-card.elevation-0.px-md-10.pt-5
            v-row
              v-col(cols="12" md="6" sm="12").px-md-10.text-center
                v-card(color="primary" dark).elevation-10
                  MonthlyUserChart(:chart="dailyUsersChart")
                h2.py-5 DAU/MAU
              v-col(cols="12" md="6" sm="12").px-md-10.text-center
                v-card(color="primary" dark).elevation-10
                  RegistrationChart(:chart="registrationUsersChart")
                h2.py-5 {{translations.chars.registeredUsers}}
      v-col(cols="12")
          h2 {{translations.gamesSection}}
          v-divider
          v-row.py-6
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topRevenue" labelbackcolor="green lighten-1", :items="gameBalanceListAllTop")
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topLoss" labelbackcolor="red lighten-1", :items="gameBalanceListAllFlop")
      v-col(cols="12")
          h2 {{translations.playersSection}}
          v-divider
          v-row.py-6
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topWinners" labelbackcolor="green lighten-1", :items="playersBalanceListAllWinners")
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topLosers" labelbackcolor="red lighten-1", :items="playersBalanceListAllLosers")
      v-col(cols="12")
          h2 {{translations.providersSection}}
          v-divider
          v-row.py-6
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topRevenue" labelbackcolor="green lighten-1", :items="providerBalanceListAllTop")
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topLoss" labelbackcolor="red lighten-1", :items="providerBalanceListAllFlop")
      v-col(cols="12")
          h2 {{translations.operatorsSection}}
          v-divider
          v-row.py-6
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topRevenue" labelbackcolor="green lighten-1", :items="operatorBalanceListAllTop")
            v-col(cols="12" md="6" sm="12")
              BalanceCard(:labeltext="translations.sections.topLoss" labelbackcolor="red lighten-1", :items="operatorBalanceListAllFlop")
</template>

<script>

  import LineChart from "@/components/charts/LineChart";
  import BarChart from "@/components/charts/BarChart";
  import RevenueChart from "@/components/charts/RevenueChart";
  import MoneyCharts from "@/components/charts/MoneyCharts";
  import DailyUserChart from "@/components/charts/DailyUserChart";
  import MonthlyUserChart from "@/components/charts/MonthlyUserChart";
  import RegistrationChart from "@/components/charts/RegistrationChart";
  import MoneyLineChart from "@/components/charts/MoneyLineChart";
  import moment from 'moment';
  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: 'Home',
    components: {
      MoneyLineChart,
      RegistrationChart,
      MonthlyUserChart,
      DailyUserChart,
      MoneyCharts,
      RevenueChart,
      BarChart,
      LineChart
    },
    data:() => ({
      currencyList,
      text: 'center',
      icon: 'justify',
      toggle_none: null,
      toggle_one: 0,
      toggle_exclusive: 1,
      customDate: [],
        menu:false
    }),
    computed:{
      translations(){
        return this.$t("views.dashboardIndex");
      },
      moneyChart(){
        return {
          type: 'moneyChart',
          moneyIn: this.moneyIn,
          moneyOut: this.moneyOut
        };
      },
      moneyOut(){
        return this.revenueListAll.map(revenue => ({
          x: `${revenue._id.date}`,
          y: revenue.mout
        }))
      },
      moneyIn(){
        return this.revenueListAll.map(revenue => ({
          x: `${revenue._id.date}`,
          y: revenue.min
        }))
      },
      reneuveChart(){     // FIXME, igual que moneyOut()
        return this.revenueListAll.map(revenue => ({
          x: `${revenue._id.date}`,
          y: revenue.mout
        }))
      },
      dailyUsersChart(){
        return this.usersListAll.map(users => ({
          x: `${users._id.date}`,
          y: users.count
        }))
      },
      registrationUsersChart(){
        return this.registeredUsersListAll.map(users => ({
          x: `${users._id.date}`,
          y: users.count
        })).slice().sort((a, b) => b.x - a.x)
      },
      revenueListAll(){
        return this.$store.state.reporting.revenue;
      },
      usersListAll(){
        return this.$store.state.reporting.users;
      },
      registeredUsersListAll(){
        return this.$store.state.reporting.registrations;
      },
      playersBalanceListAll(){
        return this.$store.state.reporting.playersBalance;
      },
      playersBalanceListAllWinners(){
        if(this.playersBalanceListAll.winners != undefined && this.playersBalanceListAll.winners.length > 0){
          return this.playersBalanceListAll.winners.map((item) => ({
            text: `${item.bookmaker.n} / ${item.user.r}`,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.c, 'playersBalanceListAllWinners'))
          }))
        } else {
          return []
        }
      },
      playersBalanceListAllLosers(){
        if(this.playersBalanceListAll.loosers != undefined && this.playersBalanceListAll.loosers.length > 0){
          return this.playersBalanceListAll.loosers.map((item) => ({
            text: `${item.bookmaker.n} / ${item.user.r}`,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'playersBalanceListAllLosers'))
          }))
        } else {
          return []
        }
      },
      gameBalanceListAll(){
        return this.$store.state.reporting.gamesBalance;
      },
      gameBalanceListAllTop(){
        if(this.gameBalanceListAll.top != undefined && this.gameBalanceListAll.top.length > 0){
          return this.gameBalanceListAll.top.map((item) => ({
            text: item.game.n,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'gameBalanceListAllTop'))
          }))
        } else {
          return []
        }
      },
      gameBalanceListAllFlop(){
        if(this.gameBalanceListAll.flop != undefined && this.gameBalanceListAll.flop.length > 0){
          return this.gameBalanceListAll.flop.map((item) => ({
              text: item.game.n,
              value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'gameBalanceListAllFlop'))
          }))
        } else {
          return []
        }
      },
      providerBalanceListAll(){
        return this.$store.state.reporting.providersBalance;
      },
      providerBalanceListAllTop(){
        if(this.providerBalanceListAll.top != undefined && this.providerBalanceListAll.top.length > 0){
          return this.providerBalanceListAll.top.map((item) => ({
              text: item.provider.n,
              value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'providerBalanceListAllTop'))
          }))
        } else {
          return []
        }
      },
      providerBalanceListAllFlop(){
        if(this.providerBalanceListAll.flop != undefined && this.providerBalanceListAll.flop.length > 0){
          return this.providerBalanceListAll.flop.map((item) => ({
            text: item.provider.n,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'providerBalanceListAllFlop'))
          }))
        } else {
          return []
        }
      },
      operatorBalanceListAll(){
        return this.$store.state.reporting.operatorsBalance;
      },
      operatorBalanceListAllTop(){
        if(this.operatorBalanceListAll.top != undefined && this.operatorBalanceListAll.top.length > 0){
          return this.operatorBalanceListAll.top.map((item) => ({
            text: item.bookmaker.n,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'operatorBalanceListAllTop'))
          }))
        } else {
          return []
        }
      },
      operatorBalanceListAllFlop(){
        if(this.operatorBalanceListAll.flop != undefined && this.operatorBalanceListAll.flop.length > 0){
          return this.operatorBalanceListAll.flop.map((item) => ({
            text: item.bookmaker.n,
            value: this.currencyFormat(item.revenue, this.getCurrency(item._id.currency, 'operatorBalanceListAllFlop'))
          }))
        } else {
          return []
        }
      },
    },
    created(){
      let filter = {
        start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      };
      this.getChars(filter);
    },
    methods:{
      getLastWeek(){
        let from = moment().subtract(7, 'days').format('YYYY-MM-DD');
        let to =  moment().format('YYYY-MM-DD');

        let filter = {
          start:from,
          end:to
        };
        this.getChars(filter);
      },
      getLastMonth(){
        let from =  moment().subtract(1, 'months').format('YYYY-MM-DD');
        let to = moment().format('YYYY-MM-DD');

        let filter = {
          start:from,
          end:to
        };
        this.getChars(filter);
      },
      getLastYear(){
        let from = moment().subtract(1, 'years').format('YYYY-MM-DD');
        let to = moment().format('YYYY-MM-DD');

        let filter = {
          start:from,
          end:to
        };
        this.getChars(filter);
      },
      getLastTwoYears(){
        let from = moment().subtract(2, 'years').format('YYYY-MM-DD');
        let to = moment().format('YYYY-MM-DD');

        let filter = {
          start:from,
          end:to
        };
        this.getChars(filter);
      },
      getCustomDate(){
        let [fromDate, toDate] = this.customDate;

        let _this = this;
        if(toDate != undefined){
          let to = toDate;
          let from = fromDate;
          if(fromDate > toDate){
            to = fromDate;
            from = toDate;
          }
          let filter = {
            start:from,
            end:to
          };
          this.getChars(filter);
          setTimeout(function () {
              _this.menu = false;
          },200)
        }
      },
      getChars(filter){
        this.$store.dispatch('getRevenue',filter);
        this.$store.dispatch('getUsersCharts',filter);
        this.$store.dispatch('getRegistrations',filter);
        this.$store.dispatch('getGamesBalance',filter);
        this.$store.dispatch('getProvidersBalance',filter);
        this.$store.dispatch('getOperatorsBalance',filter);
        this.$store.dispatch('getPlayersBalance',filter);
      },
      getCurrency(currentCurrency) {
        let curr = this.currencyList.find(item=> item.value === currentCurrency );
        return curr == undefined ? {} : curr.text;
      },
    }
  }
</script>

<style lang="sass">
</style>
